export const SCHEDULE_GAMES = {
  YUGIOH: 'Yu-Gi-Oh!',
  MTG_CASUAL: 'Casual Commander MTG',
  MTG_COMP: 'Competitive MTG',
  MTG_EVENTS: 'MTG event day',
  ONE_PIECE: 'One Piece',
  POKEMON: 'Pokémon',
  DND: 'Dungeons & Dragons',
};
const DEFAULT_HOURS = { open: '11:00', close: '22:00' };

const day = (hours = {}, games = []) => ({
  ...DEFAULT_HOURS,
  ...hours,
  games: games.map((game) => SCHEDULE_GAMES[game]),
});

export const SCHEDULE = {
  monday: day({}, ['ONE_PIECE', 'YUGIOH', 'MTG_CASUAL']),
  tuesday: day({}, ['MTG_CASUAL']),
  wednesday: {},
  thursday: day({}, ['DND', 'MTG_CASUAL']),
  friday: day({ close: '23:00' }, ['MTG_COMP', 'MTG_CASUAL']),
  saturday: day({ open: '09:00', close: '17:00' }, ['YUGIOH', 'MTG_CASUAL']),
  sunday: day({ open: '10:00', close: '16:00' }, ['MTG_EVENTS', 'MTG_CASUAL']),
};
